// extracted by mini-css-extract-plugin
export default {"apPdpPage":"apPdpPage__1chu7","apPdpPageTitle":"apPdpPageTitle__hFieB","apPdpPageText":"apPdpPageText__1pA_L"};